import CircularProgress from '@material-ui/core/CircularProgress';
import ImageLoader from 'react-load-image';
import React from 'react';
import RemoveButton from '../Atoms/RemoveButton';

interface ISimpleImageLoader {
    src: string | null;
    width: number;
    alt: string;
    className?: string;
    options?: {
        removeButton?: boolean;
        confirmationTitle?: string;
        handleRemove?: any;
    };
}
const SimpleImageLoader = ({ alt, className, options, src, width }: ISimpleImageLoader) => {
    return (
        <div style={{ position: 'relative', maxWidth: '300px', margin: '0 auto' }}>
            {options && options.handleRemove && options.removeButton && options.confirmationTitle && (
                <RemoveButton confirmationTitle={options.confirmationTitle} handleRemove={options.handleRemove} />
            )}
            <ImageLoader src={src} width={width}>
                <img alt={alt} className={className} width={width} />
                <div>Error!</div>
                <CircularProgress />
            </ImageLoader>
        </div>
    );
};
export default SimpleImageLoader;
